export default __webpack_public_path__ + "afc1318ea5d0f5101190560cf7650c9e.jpg";